<template>
  <div class="project-settings">
    <div
      class="project-settings__list project-settings__list--mute"
      v-if="$route.matched[0].name != 'Inbox'"
      @click="muteOrUnmute"
    >
      <span class="project-settings__icon" aria-hidden="true">
        <svg
          v-if="mute.bool"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 5 6 9H3v6h3l5 4V5Z" />
          <path d="m17 9 4 4m0-4-4 4" />
        </svg>
        <svg
          v-else
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 5 6 9H3v6h3l5 4V5Z" />
          <path d="M15.5 8.5a5 5 0 0 1 0 7" />
          <path d="M18.5 5.5a9 9 0 0 1 0 13" />
        </svg>
      </span>
      <p>{{ mute.text }}</p>
    </div>
    <div
      class="project-settings__list"
      @click="show_popup"
      v-if="$route.matched[0].name != 'Inbox'"
    >
      <span class="project-settings__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M19 8v6m-3-3h6" />
        </svg>
      </span>
      <p>{{ $t("list.share") }}</p>
    </div>
    <div
      class="project-settings__list project-settings__list--sort"
      @click="show_filter_list($event)"
      v-if="$route.matched[0].name != 'Inbox'"
    >
      <span class="project-settings__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 4v16m0-16L4 8m4-4 4 4" />
          <path d="M16 20V4m0 16-4-4m4 4 4-4" />
        </svg>
      </span>
      <p>{{ $t("list.sort") }}</p>
      <ul class="order_list" v-if="show_sort">
        <li>
          <button @click="filterTasksBy('name', $event)">
            <ContextMenuIcon type="sort-name" />
            {{ $t("list.by_name") }}
          </button>
        </li>
        <li>
          <button @click="filterTasksBy('date', $event)">
            <ContextMenuIcon type="sort-date" />
            {{ $t("list.creation_date") }}
          </button>
        </li>
        <li>
          <button @click="filterTasksBy('prior', $event)">
            <ContextMenuIcon type="sort-priority" />
            {{ $t("list.by_priority") }}
          </button>
        </li>
      </ul>
    </div>
  </div>
  <!-- <div class="project_setting" ref="project_setting">
        <AddUserToProject @show_drawer="show_drawer" :project_id="project_id" />
        <div @click="rename_element(`${project_name}_${project_id}`)">
            <p>
                <i class="el-icon-edit"></i>
                <span>Rename</span>
            </p>
        </div>
        <hr />
        <div @click="delete_project">
            <p>
                <i class="el-icon-delete"></i>
                <span>Delete project</span>
            </p>
        </div>
    </div> -->
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AddUserToProject from "./AddUserToProject";
import File from "../../utils/aws";
import { EventEmitter } from "../../main";
import ContextMenuIcon from "@/components/app/ContextMenuIcon.vue";

export default {
  name: "ProjectSetting",
  props: {
    project_id: [String, Number],
    project_name: [String],
  },
  data() {
    return {
      mute: {
        bool: false,
        svg: `
                    <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.166656 11.1667V6.83334C0.166656 6.54602 0.280793 6.27047 0.483957 6.06731C0.687122 5.86414 0.962672 5.75001 1.24999 5.75001H4.17174C4.38573 5.75005 4.59495 5.68672 4.77299 5.56801L9.31541 2.53901C9.47871 2.43005 9.66855 2.36752 9.86464 2.35809C10.0607 2.34867 10.2557 2.3927 10.4287 2.48549C10.6017 2.57827 10.7462 2.71633 10.8469 2.88489C10.9475 3.05345 11.0004 3.24619 11 3.44251V14.5575C11 14.7536 10.9468 14.9461 10.846 15.1143C10.7452 15.2826 10.6007 15.4203 10.4277 15.5129C10.2548 15.6054 10.06 15.6492 9.8641 15.6397C9.6682 15.6302 9.47856 15.5677 9.31541 15.4588L4.77299 12.4309C4.59483 12.3126 4.38562 12.2496 4.17174 12.25H1.24999C0.962672 12.25 0.687122 12.1359 0.483957 11.9327C0.280793 11.7295 0.166656 11.454 0.166656 11.1667V11.1667Z" stroke="#000000" stroke-width="0.9"/>
                        <path d="M15.875 4.125C15.875 4.125 17.5 5.75 17.5 8.45833C17.5 11.1667 15.875 12.7917 15.875 12.7917" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.125 0.875C19.125 0.875 21.8333 3.58333 21.8333 8.45833C21.8333 13.3333 19.125 16.0417 19.125 16.0417" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    `,
        text: this.$t("list.mute"),
      },
      show_sort: false,
    };
  },
  methods: {
    ...mapActions([
      "socket_add_user",
      "socket_change_order",
      "socket_delete_project",
      "socket_rename_project",
    ]),
    ...mapMutations(["setUserFileSize_minus"]),
    muteOrUnmute() {
      if (!this.mute.bool) {
        this.changeMuteStatus(true);
        this.mute = {
          bool: true,
          svg: `
                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.5833 8.00001L20.75 10.1667M16.4167 10.1667L18.5833 8.00001L16.4167 10.1667ZM20.75 5.83334L18.5833 8.00001L20.75 5.83334ZM18.5833 8.00001L16.4167 5.83334L18.5833 8.00001Z" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.25 10.1667V5.83334C1.25 5.54602 1.36414 5.27047 1.5673 5.06731C1.77047 4.86414 2.04602 4.75001 2.33333 4.75001H5.25508C5.46908 4.75005 5.67829 4.68672 5.85633 4.56801L10.3988 1.53901C10.5621 1.43005 10.7519 1.36752 10.948 1.35809C11.1441 1.34867 11.339 1.3927 11.512 1.48549C11.685 1.57827 11.8296 1.71633 11.9302 1.88489C12.0308 2.05345 12.0838 2.24619 12.0833 2.44251V13.5575C12.0834 13.7536 12.0301 13.9461 11.9294 14.1143C11.8286 14.2826 11.684 14.4203 11.5111 14.5129C11.3381 14.6054 11.1433 14.6492 10.9474 14.6397C10.7515 14.6302 10.5619 14.5677 10.3988 14.4588L5.85633 11.4309C5.67817 11.3126 5.46897 11.2496 5.25508 11.25H2.33333C2.04602 11.25 1.77047 11.1359 1.5673 10.9327C1.36414 10.7295 1.25 10.454 1.25 10.1667Z" stroke="#000000" stroke-width="0.9"/>
                        </svg>`,
          text: this.$t("list.unmute"),
        };
      } else {
        this.changeMuteStatus(false);
        this.mute = {
          bool: false,
          svg: `
                        <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.166656 11.1667V6.83334C0.166656 6.54602 0.280793 6.27047 0.483957 6.06731C0.687122 5.86414 0.962672 5.75001 1.24999 5.75001H4.17174C4.38573 5.75005 4.59495 5.68672 4.77299 5.56801L9.31541 2.53901C9.47871 2.43005 9.66855 2.36752 9.86464 2.35809C10.0607 2.34867 10.2557 2.3927 10.4287 2.48549C10.6017 2.57827 10.7462 2.71633 10.8469 2.88489C10.9475 3.05345 11.0004 3.24619 11 3.44251V14.5575C11 14.7536 10.9468 14.9461 10.846 15.1143C10.7452 15.2826 10.6007 15.4203 10.4277 15.5129C10.2548 15.6054 10.06 15.6492 9.8641 15.6397C9.6682 15.6302 9.47856 15.5677 9.31541 15.4588L4.77299 12.4309C4.59483 12.3126 4.38562 12.2496 4.17174 12.25H1.24999C0.962672 12.25 0.687122 12.1359 0.483957 11.9327C0.280793 11.7295 0.166656 11.454 0.166656 11.1667V11.1667Z" stroke="#000000" stroke-width="0.9"/>
                            <path d="M15.875 4.125C15.875 4.125 17.5 5.75 17.5 8.45833C17.5 11.1667 15.875 12.7917 15.875 12.7917" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.125 0.875C19.125 0.875 21.8333 3.58333 21.8333 8.45833C21.8333 13.3333 19.125 16.0417 19.125 16.0417" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        `,
          text: this.$t("list.mute"),
        };
      }
    },
    changeMuteStatus(status) {
      if (status === false || status === true) {
        // console.log('mute/unmute ', status);

        this.$socket.emit("IN_MutedProject", {
          project_id: this.project_id,
          muted: status ? true : false,
        });
      }
    },
    storageAvailable(type) {
      let storage;
      try {
        storage = window[type];
        let x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return (
          e instanceof DOMException &&
          // everything except Firefox
          (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === "QuotaExceededError" ||
            // Firefox
            e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
          // acknowledge QuotaExceededError only if there's something already stored
          storage &&
          storage.length !== 0
        );
      }
    },
    show_drawer() {
      setTimeout(() => {
        const modal = document.querySelector(".v-modal");
        this.$refs.project_setting.parentElement.style.zIndex =
          +window.getComputedStyle(modal).zIndex + 1;
      }, 0);
    },
    delete_project() {
      const deletedProjectIndex = this.getProjects.findIndex(
        (project) => project._id == this.project_id
      );
      const next_or_prev_project = this.getProjects[deletedProjectIndex + 1]
        ? this.getProjects[deletedProjectIndex + 1]
        : this.getProjects[deletedProjectIndex - 1];
      // ----
      const projects = this.getProjects;
      projects.forEach((p) => {
        if (p._id == this.project_id) {
          const tasks = this.getTasks[p._id];
          tasks.forEach((t) => {
            const msgs = this.getComments[t._id];
            msgs.forEach((m) => {
              m.files.forEach((f) => {
                this.setUserFileSize_minus(+f.size);
              });
            });
          });
        }
      });
      this.socket_delete_project(this.project_id);
      const aws = new File();
      const remove = aws.removeFolder("Lists" + "/" + this.project_id);
      if (next_or_prev_project) {
        this.$router.push(`/project/${next_or_prev_project._id}`);
      } else {
        this.$router.push("/");
      }
    },
    rename_element(data) {
      document.getElementById(data).focus();
    },
    show_popup() {
      this.$root.$emit("addRenameProjectAddUser", this.project_id);
    },
    show_filter_list(event) {
      event.stopPropagation();
      this.show_sort = !this.show_sort;
      // if (event.target.localName == "p" || event.target.localName == "svg") {
      //     // let order_list = document.querySelector(".order_list")
      //     // if (order_list.classList.contains("active")) {
      //     //     order_list.classList.remove("active")
      //     //     setTimeout(() => {
      //     //         order_list.classList.add("hide")
      //     //     }, 500);
      //     // } else {
      //     //     order_list.classList.remove("hide")
      //     //     setTimeout(() => {
      //     //         order_list.classList.add("active")
      //     //     }, 100)
      //     // }
      // }
    },
    filterTasksBy(type, event) {
      // console.log(this);

      const order_list = document.querySelector(".order_list");

      // filter
      let tasks = this.getTasks[this.$route.params.project_id];
      if (tasks) {
        let max_order = tasks.length + 1;

        let now = Date.now(),
          hight_order = 1,
          mid_order = 1000,
          normal_order = 1000000,
          filtered_tasks = [],
          filtered_tasks_by_section = [];

        // setTimeout(() => {
        tasks.forEach((task) => {
          if (task.parent == "") {
            let old_order = task.order;

            switch (type) {
              case "date":
                task.order = now - task.date;
                break;
              case "name":
                // let cur_name = document.querySelector(`[id="task_${task._id}"] .task_title`).innerHTML;
                // console.log('------------- By name ---------------')
                // console.log(cur_name)
                filtered_tasks.push(task.name.toLowerCase());
                break;
              case "prior":
                let cur_prior = document.querySelector(
                  `[id="task_${task._id}"] .task__priority__title p`
                ).innerHTML;
                // console.log('------------- By prior ---------------')
                // console.log(cur_prior)
                // console.log(task.priority)
                // console.log('-----------------------------')
                if (cur_prior == "High") {
                  task.order = hight_order++;
                } else if (cur_prior == "Medium") {
                  task.order = mid_order++;
                } else {
                  task.order = normal_order++;
                }
                break;
              default:
                break;
            }
          }
        });
        // }, 1000)

        if (type == "name" && filtered_tasks.length != 0) {
          filtered_tasks = filtered_tasks.sort();
          tasks.forEach((task) => {
            if (task.parent == "") {
              // let cur_name = document.querySelector(`[id="task_${task._id}"] .task_title`).innerHTML;
              task.order = filtered_tasks.indexOf(task.name.toLowerCase());
            }
          });
        }

        tasks.forEach((task) => {
          if (task.parent == "" && task.section != "") {
            if (!filtered_tasks_by_section[task.section])
              filtered_tasks_by_section[task.section] = [];

            filtered_tasks_by_section[task.section][task._id] = task.order;
          }
        });
        // console.log('Filtered tasks by section:');
        // console.log(filtered_tasks_by_section);

        this.setOrderToProject(type);
        EventEmitter.$emit("change_task_order_after_filter", true);
        EventEmitter.$emit(
          "change_sections_task_order_after_filter",
          filtered_tasks_by_section
        );
      }

      order_list.classList.remove("active");
      setTimeout(() => {
        order_list.classList.add("hide");

        // save order to backend
        let all_tasks = document.querySelectorAll(
          ".draggable_tasks > .draggable_tasks_group > .task_box"
        );
        // console.log(all_tasks);

        let new_order = [];
        all_tasks.forEach((div, pos) => {
          if (div.attributes["data-id"]) {
            new_order.push({
              name: div.attributes["data-name"].value,
              task_id: div.attributes["data-id"].value,
              order: pos,
              section_id: div.attributes["data-section"].value,
            });
          }
          // console.log(div.attributes['data-id'].value);
          // console.log('order: ' + order);
        });
        /*
                    new_order.push({
                        task_id: task._id,
                        order: task.order
                    })
                  */

        const new_order_position = {
          out: true,
          new_order: new_order,
          project_id: this.project_id,
        };
        // console.log('new_order_position', new_order_position);
        this.socket_change_order({ new_order_position, add_global: true });
      }, 500);
    },
    setOrderToProject(order = "") {
      // console.log('project data : --------------');
      this.getProjects.map((project) => {
        if (project._id == this.project_id && order != "") {
          // project.order = order;
          // console.log(project);
          this.$socket.emit("IN_ListsOrderBy", {
            list_id: project._id,
            order_by: order,
          });
        }
      });
    },
    setCurrentMuteStatus() {
      // console.log('setCurrentMuteStatus() --- ');

      if (
        this.storageAvailable("localStorage") &&
        window.localStorage.getItem("mutedObjects")
      ) {
        let mutedObjects = window.localStorage
          .getItem("mutedObjects")
          .split(",");

        // console.log('mutedObjects ', mutedObjects)
        if (mutedObjects.includes(this.$route.params.project_id)) {
          this.mute.bool = true;
          this.mute.text = this.$t("list.unmute");
          this.mute.svg = `
                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.5833 8.00001L20.75 10.1667M16.4167 10.1667L18.5833 8.00001L16.4167 10.1667ZM20.75 5.83334L18.5833 8.00001L20.75 5.83334ZM18.5833 8.00001L16.4167 5.83334L18.5833 8.00001Z" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.25 10.1667V5.83334C1.25 5.54602 1.36414 5.27047 1.5673 5.06731C1.77047 4.86414 2.04602 4.75001 2.33333 4.75001H5.25508C5.46908 4.75005 5.67829 4.68672 5.85633 4.56801L10.3988 1.53901C10.5621 1.43005 10.7519 1.36752 10.948 1.35809C11.1441 1.34867 11.339 1.3927 11.512 1.48549C11.685 1.57827 11.8296 1.71633 11.9302 1.88489C12.0308 2.05345 12.0838 2.24619 12.0833 2.44251V13.5575C12.0834 13.7536 12.0301 13.9461 11.9294 14.1143C11.8286 14.2826 11.684 14.4203 11.5111 14.5129C11.3381 14.6054 11.1433 14.6492 10.9474 14.6397C10.7515 14.6302 10.5619 14.5677 10.3988 14.4588L5.85633 11.4309C5.67817 11.3126 5.46897 11.2496 5.25508 11.25H2.33333C2.04602 11.25 1.77047 11.1359 1.5673 10.9327C1.36414 10.7295 1.25 10.454 1.25 10.1667Z" stroke="#000000" stroke-width="0.9"/>
                        </svg>
                    `;
        } else {
          this.mute.bool = false;
          this.mute.text = this.$t("list.mute");
          this.mute.svg = `
                        <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.166656 11.1667V6.83334C0.166656 6.54602 0.280793 6.27047 0.483957 6.06731C0.687122 5.86414 0.962672 5.75001 1.24999 5.75001H4.17174C4.38573 5.75005 4.59495 5.68672 4.77299 5.56801L9.31541 2.53901C9.47871 2.43005 9.66855 2.36752 9.86464 2.35809C10.0607 2.34867 10.2557 2.3927 10.4287 2.48549C10.6017 2.57827 10.7462 2.71633 10.8469 2.88489C10.9475 3.05345 11.0004 3.24619 11 3.44251V14.5575C11 14.7536 10.9468 14.9461 10.846 15.1143C10.7452 15.2826 10.6007 15.4203 10.4277 15.5129C10.2548 15.6054 10.06 15.6492 9.8641 15.6397C9.6682 15.6302 9.47856 15.5677 9.31541 15.4588L4.77299 12.4309C4.59483 12.3126 4.38562 12.2496 4.17174 12.25H1.24999C0.962672 12.25 0.687122 12.1359 0.483957 11.9327C0.280793 11.7295 0.166656 11.454 0.166656 11.1667V11.1667Z" stroke="#000000" stroke-width="0.9"/>
                            <path d="M15.875 4.125C15.875 4.125 17.5 5.75 17.5 8.45833C17.5 11.1667 15.875 12.7917 15.875 12.7917" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.125 0.875C19.125 0.875 21.8333 3.58333 21.8333 8.45833C21.8333 13.3333 19.125 16.0417 19.125 16.0417" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    `;
        }
      }
    },
  },
  mounted() {
    this.$root.$on("onboard:share", () => {
      this.show_popup();
    });

    document.onclick = () => {
      if (this.show_sort) {
        this.show_sort = false;
      }
    };

    this.getProjects.map((project) => {
      // if (project._id == this.$route.params.project_id && project.order_by) {
      if (project.order_by != "") {
        let tasks = this.getTasks[project._id];
        // let max_order = tasks.length + 1;

        let now = Date.now();
        let hight_order = 1;
        let mid_order = 1000;
        let normal_order = 1000000;
        let filtered_tasks = [];

        if (tasks) {
          tasks.forEach((task) => {
            if (task.parent == "") {
              switch (project.order_by) {
                case "date":
                  task.order = now - task.date;
                  break;
                case "name":
                  filtered_tasks.push(task.name.toLowerCase());
                  break;
                case "prior":
                  if (task.priority == "High") {
                    task.order = hight_order++;
                  } else if (task.priority == "Medium") {
                    task.order = mid_order++;
                  } else {
                    task.order = normal_order++;
                  }
                  break;
                default:
                  break;
              }
            }
          });

          if (project.order_by == "name" && filtered_tasks.length != 0) {
            filtered_tasks = filtered_tasks.sort();
            tasks.forEach((task) => {
              if (task.parent == "") {
                task.order = filtered_tasks.indexOf(task.name.toLowerCase());
              }
            });
          }
        }
      }

      if (project._id == this.$route.params.project_id) {
        this.setCurrentMuteStatus();
      }
    });

    EventEmitter.$on("ProjectMuted", (data) => {
      if (data.project_id == this.project_id) {
        if (data.muted) {
          this.mute = {
            bool: true,
            svg: `
                            <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.5833 8.00001L20.75 10.1667M16.4167 10.1667L18.5833 8.00001L16.4167 10.1667ZM20.75 5.83334L18.5833 8.00001L20.75 5.83334ZM18.5833 8.00001L16.4167 5.83334L18.5833 8.00001Z" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1.25 10.1667V5.83334C1.25 5.54602 1.36414 5.27047 1.5673 5.06731C1.77047 4.86414 2.04602 4.75001 2.33333 4.75001H5.25508C5.46908 4.75005 5.67829 4.68672 5.85633 4.56801L10.3988 1.53901C10.5621 1.43005 10.7519 1.36752 10.948 1.35809C11.1441 1.34867 11.339 1.3927 11.512 1.48549C11.685 1.57827 11.8296 1.71633 11.9302 1.88489C12.0308 2.05345 12.0838 2.24619 12.0833 2.44251V13.5575C12.0834 13.7536 12.0301 13.9461 11.9294 14.1143C11.8286 14.2826 11.684 14.4203 11.5111 14.5129C11.3381 14.6054 11.1433 14.6492 10.9474 14.6397C10.7515 14.6302 10.5619 14.5677 10.3988 14.4588L5.85633 11.4309C5.67817 11.3126 5.46897 11.2496 5.25508 11.25H2.33333C2.04602 11.25 1.77047 11.1359 1.5673 10.9327C1.36414 10.7295 1.25 10.454 1.25 10.1667Z" stroke="#000000" stroke-width="0.9"/>
                            </svg>`,
            text: this.$t("list.unmute"),
          };
        } else {
          this.mute = {
            bool: false,
            svg: `
                            <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.166656 11.1667V6.83334C0.166656 6.54602 0.280793 6.27047 0.483957 6.06731C0.687122 5.86414 0.962672 5.75001 1.24999 5.75001H4.17174C4.38573 5.75005 4.59495 5.68672 4.77299 5.56801L9.31541 2.53901C9.47871 2.43005 9.66855 2.36752 9.86464 2.35809C10.0607 2.34867 10.2557 2.3927 10.4287 2.48549C10.6017 2.57827 10.7462 2.71633 10.8469 2.88489C10.9475 3.05345 11.0004 3.24619 11 3.44251V14.5575C11 14.7536 10.9468 14.9461 10.846 15.1143C10.7452 15.2826 10.6007 15.4203 10.4277 15.5129C10.2548 15.6054 10.06 15.6492 9.8641 15.6397C9.6682 15.6302 9.47856 15.5677 9.31541 15.4588L4.77299 12.4309C4.59483 12.3126 4.38562 12.2496 4.17174 12.25H1.24999C0.962672 12.25 0.687122 12.1359 0.483957 11.9327C0.280793 11.7295 0.166656 11.454 0.166656 11.1667V11.1667Z" stroke="#000000" stroke-width="0.9"/>
                                <path d="M15.875 4.125C15.875 4.125 17.5 5.75 17.5 8.45833C17.5 11.1667 15.875 12.7917 15.875 12.7917" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M19.125 0.875C19.125 0.875 21.8333 3.58333 21.8333 8.45833C21.8333 13.3333 19.125 16.0417 19.125 16.0417" stroke="#000000" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            `,
            text: this.$t("list.mute"),
          };
        }
      }
    });
  },
  computed: {
    ...mapGetters(["getProjects", "getTasks", "getComments", "getUserData"]),
  },
  components: {
    AddUserToProject,
    ContextMenuIcon,
  },
  watch: {
    $route(e) {
      // if (e.name == 'Project') {
      // this.setCurrentMuteStatus();
      // }
    },
  },
};
</script>
